<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1280px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          is-select-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          :multiple-selection.sync="multipleSelection"
          @reloadData="loadTableData(tableList)"
          @submit="submitFun"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
import { loadMaterialsDemandListDataApi, submitMaterialsDemandApi } from '@/api/materialsDemandDetail'

export default {
  name: 'MaterialsDemandTodoSubmitList',
  components: { CustomTable },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'materials_demand_task_submit_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'submit',
            label: '提交',
            method: 'submit'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {
            status: 1
          }
        }
      },
      isPaging: true,
      typeOptions: [{ value: 1, label: '方案内需求' }, { value: 2, label: '方案外需求' }],
      multipleSelection: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.multipleSelection = []
        this.tableList.initTableColumn = [
          // { prop: 'typeValue', label: '需求类型', filterColumn: 'type', filterValue: 'type', filterArray: this.typeOptions, width: 105 },
          { prop: 'provinceName', label: '省区', filterColumn: 'province_name', width: 90 },
          { prop: 'cityName', label: '市场', filterColumn: 'city_name', width: 90 },
          { prop: 'schemeContent', label: '需求来源', filterColumn: 'scheme_content', width: 240 },
          { prop: 'demandSide', label: '需求方', filterColumn: 'demand_side', width: 110 },
          { prop: 'viewMaterialsName', label: '需求物料名称', filterColumn: '(case type when 1 then demand_materials_name else materials_name end)' },
          { prop: 'viewMaterialsNumber', label: '需求物料数量', filterColumn: '(case type when 1 then demand_materials_number else apply_make_number end)', width: 125, isBetween: true },
          { prop: 'executeMethodValue', label: '需求执行方式', filterColumn: 'execute_method', filterValue: 'executeMethod', filterArray: this.executeMethodOptions, width: 125 },
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.tableList.tableQuery.sort.order = ''
        this.searchData(this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.tableList.tableLoading = true
      loadMaterialsDemandListDataApi({ condition: JSON.stringify(this.tableList.tableQuery) }).then(response => {
        this.tableList.tableLoading = false
        let data = response.data.data || []
        this.handleData(this.tableList, data)
        this.tableList.tableDataTotal = response.data.recordsTotal || 0
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 刷新列表
    reloadMasterData () {
      this.$emit('reloadData')
      this.loadTableData(this.tableList)
    },
    // 提交
    submitFun () {
      if (this.multipleSelection.length === 0) {
        this.$message({ message: '请选择要提交的物料需求申请', type: 'warning' })
        return false
      }
      let ids = ''
      this.multipleSelection.forEach(item => {
        ids = ids + ',' + item.id
      })
      ids = ids.substring(1)
      this.$confirm('是否确定提交物料需求申请？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        submitMaterialsDemandApi({ ids: ids, submitBatch: 'true' }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.reloadMasterData()
          }
        })
      }).catch(() => { })
    },
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
